module.exports = __webpack_public_path__ + "img/NukedTV-Web_03.90072f7b.png";